import { render, staticRenderFns } from "./message-bubble-web.vue?vue&type=template&id=03e8ceb0&scoped=true"
import script from "./message-bubble-web.vue?vue&type=script&lang=ts"
export * from "./message-bubble-web.vue?vue&type=script&lang=ts"
import style0 from "./message-bubble-web.vue?vue&type=style&index=0&id=03e8ceb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8ceb0",
  null
  
)

export default component.exports